<template lang="pug">
  div
    div.wrap-search
      ModuleSearch(v-if="users[0]" :users="users")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-search {
  width: 100%;
  min-height: 100vh;
  background: $secondary_bg_color;
}
</style>

<script>
import database from '@/database'
import ModuleSearch from '@/components/module/ModuleSearch'

export default {
  components: {
    ModuleSearch
  },
  data () {
    return {
      users: []
    }
  },
  async created () {
    this.users = await database.userCollection().getAllOrderByDisplayName()
    console.log('this.users:', this.users)
  }
}
</script>
